import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { LogInService } from './login-service';
import { Utils } from './utils';

@Injectable({
    providedIn: 'root'
})

export class AuthGuardService {

    constructor(public loginService: LogInService, public router: Router) { }

    canActivate(): Promise<boolean> | UrlTree {

        ///*----------------------------------------------------------------------------------------------------*/console.log("auth-guard.service.ts : canActivate");
        if (!this.loginService.isAuthenticated()) {
            this.router.navigate(['/login']);
            //this.router.navigate(['/home']);
        }

        return this.loginService.isAuthenticated()
        // if (token) {
        //   this.router.navigate(['/']);
        //   return false;
        // }
        // return true;
    }
}
